import { JSX, useMemo, memo } from "react";
import { PhotoProvider } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { WorkingSessionImage } from "../../../../../common/types";
import WorkSessionImage from "../work-session-image";
import InfoField from "../../../../../components/Common/InfoField";
import { Container } from "reactstrap";

interface WorkSessionImageListProps {
    data: WorkingSessionImage[];
}

const WorkSessionImageList = ({ data }: WorkSessionImageListProps): JSX.Element => {
    const workingSessionImagesList = useMemo(() => data.map((data) => (
        <WorkSessionImage
            key={`work-session-image-${data.id}`}
            data={data}
        />
    )), [data]);

    return (
        <InfoField
            title="Operator Photos (click to expand)"
            titleClassName="mb-2"
        >
            <PhotoProvider>
                <Container fluid className="d-flex flex-row gap-4">
                    {workingSessionImagesList}
                </Container>
            </PhotoProvider>
        </InfoField>
    );
};

export default memo(WorkSessionImageList);